import styled from '@emotion/styled';
import { token } from '@atlaskit/tokens';

export const PageContainer = styled.div`
  .app-page {
    .app-content {
      padding-top: 0;
      .tabs-container {
        padding-left: 0;
        padding-right: 0;
        position: relative;
        top: 0;
        > div > div:first-child:not([role='tabpanel']) {
          // To target tabs section
          padding-top: 0;
          position: relative;
          overflow-y: unset;
          top: 0;
          background: ${token('elevation.surface')};
          z-index: unset; // Keeps it below the page header and its dropdowns
        }
        > div > div[role='tabpanel'] {
          background: ${token('elevation.surface')};
          padding: 0;
        }
        .tab-content {
          background: ${token('elevation.surface')};
          > div {
            box-shadow: none;
          }
        }
      }
    }
  }
`;

export const PageHeaderContainer = styled.div`
  padding-left: ${token('space.100')}; // To left align with tabs container
  > div > div {
    // To target the header content
    align-items: center;
  }
`;

export const BreadcrumbsContainer = styled.div`
  margin-bottom: ${token('space.050', '4px')};
`;

export const Subheading = styled.div`
  color: ${token('color.text')};
  font-size: 14px;
  font-weight: 400;
  margin-botom: -${token('space.100')}; // to remove the extra margin from the page header and match spacing requirement as per design
`;
